module.exports = __webpack_public_path__ + "img/電気回路_2_8.173cbfe8.png";